import { inject, Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApolloQueryResult } from '@apollo/client/core';
import { Apollo, MutationResult } from 'apollo-angular';
import { map, Observable } from 'rxjs';
import {
  BusinessDirectionIn,
  Canton,
  GetBusinessDirectionByIdDocument,
  GetBusinessDirectionByIdQuery,
  GetBusinessUnitDocument,
  GetBusinessUnitQuery,
  GetCantonesByIdDocument,
  GetProvincesDocument,
  Province,
  SaveBusinessDirectionDocument,
  SaveBusinessDirectionMutation,
  SaveBusinessDirectionMutationVariables,
} from 'src/app/graphql/types';

@Injectable({
  providedIn: 'root',
})
export class BusinessDirectionService {
  // private endpoint = environment.IDEMPIER_GATEWAY + '/v1/business-unit';
  private readonly apollo = inject(Apollo);

  get(
    id: number,
  ): Observable<ApolloQueryResult<GetBusinessDirectionByIdQuery>> {
    return this.apollo.watchQuery<GetBusinessDirectionByIdQuery>({
      query: GetBusinessDirectionByIdDocument,
      variables: {
        businessUnitId: id,
      },
    }).valueChanges;
  }

  getByBranchOfficeId(
    branchOffideId: number,
  ): Observable<ApolloQueryResult<GetBusinessUnitQuery>> {
    return this.apollo.watchQuery<GetBusinessUnitQuery>({
      query: GetBusinessUnitDocument,
      variables: { id: branchOffideId },
    }).valueChanges;
  }

  save(
    form: FormGroup,
  ): Observable<MutationResult<SaveBusinessDirectionMutation>> {
    return this.apollo.mutate<
      SaveBusinessDirectionMutation,
      SaveBusinessDirectionMutationVariables
    >({
      mutation: SaveBusinessDirectionDocument,
      variables: {
        json: this.businessDirectionIn(form),
      },
    });
  }

  private businessDirectionIn(form: FormGroup): BusinessDirectionIn {
    return {
      businessUnitId: form.get('id')?.value,
      canton: {
        id: form.get('canton')?.value,
        provinceId: form.get('province')?.value,
      },
      street: form.get('street')?.value,
      streetNumber: Number(form.get('streetNumber')?.value),
      intersection: form.get('intersection')?.value,
      storeName: form.get('storeName')?.value,
    };
  }

  getProvinces(): Observable<Province[]> {
    return this.apollo
      .watchQuery<{ getProvinces: Province[] }>({
        query: GetProvincesDocument,
      })
      .valueChanges.pipe(map(result => result.data.getProvinces));
  }

  getCantonsByProvinceId(provinceId: number): Observable<Canton[]> {
    return this.apollo
      .watchQuery<{ getCantonsById: Canton[] }>({
        query: GetCantonesByIdDocument,
        variables: { provinceId },
      })
      .valueChanges.pipe(map(result => result.data.getCantonsById));
  }
}
